import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  paper: {
    overflow: "hidden",
  },
  dialogTitle: {
    textTransform: "capitalize",
    "& > div": {
      width: "calc(100% - 32px)",
      "& > div": {
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
      },
    },
  },
  dialogContent: {
    flex: "1 1 530px",
    position: "relative",
    overflow: "auto",
  },
  input: {
    height: 86,
  },
  loading: {
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
  },
  recipientsSectionTitle: {
    marginBottom: theme.hv.spacing.sm,
  },
  templateSectionTitle: {
    marginBottom: theme.hv.spacing.sm,
  },
  buttonContainer: {},
}));

export default useStyles;
